import React, {  useEffect, useMemo, useState } from "react";
import { useDispatch ,useSelector} from "react-redux";
import { useForm } from "react-hook-form";
import { getLatLng } from "react-places-autocomplete";
import usePlacesAutocomplete, { getGeocode } from "use-places-autocomplete";
import "./style.scss";
import noteIcon from "../../common/assets/svg/note.svg";
import closeIcon from "../../common/assets/svg/closeIconRed.svg";
import editIcon from "../../common/assets/svg/othersAdd.svg";
import { addDeliveryAddress } from "../../common/features/cart/cartActions";
import {
  deliveryAddresses,
  addAddressTags,
  addDeliveryAddressRequest,
  viewDeliveryAddressRequest,
  editDeliveryAddressRequest,
  setSelectedDeliveryAddress,
} from "../../common/features/restaurant/restaurantAction";
import tagicon from "../../common/assets/svg/tag-icon.svg";
import { getDeliveryChargeInitiated } from "../../common/features/delivery/DeliveryActions";
import { DeliveryChargeRequestBody } from "../../common/features/delivery/DeliveryModels";
import { getDecimalPlacedPrice } from "../../common/utils/menu-helper-utils";
import { useOnlinePlaceOrder } from "../../hooks/useOnlinePlaceOrder";
import { ReactComponent as PositionIcon } from "../../common/assets/svg/position.svg";
import { ReactComponent as LocationIcon } from "../../common/assets/svg/location-picker.svg";
import { ReactComponent as CloseIcon } from "../../common/assets/svg/Close.svg";
import EnableLocationPrompt from "../../components/prompts/enableLocationPrompt";
import { isEmptyOrWhitespace, parseAddressFromGoogle, sanitizeAddress, validateAddress, validateTag } from "../../common/utils";
import { ADDRESS_REGEX, CITY_STATE_REGEX, defaultTags, USER_ID } from "../../common/constants";
import { getCookie } from "../../helper/cookieHelper";

interface FormData {
  addressLine1: string;
  apartment: string;
  state: string;
  city: string;
  zipcode: string;
  addressTag: string;
  deliveryInstructions: string;
  location: string;
}
interface ILatLong {
  lat: number;
  lng: number
}
interface deliveryDetailsProps {
  edit?: boolean;
  onClose?: any;
  handleDeliveryFormSubmit?: any;
  handleAddressFieldOnChange?: any;
  selectedAddress?: any;
  editAddress?: any;
  center?: ILatLong;
  isDesktop?: boolean;
  setShowForm?: any;
}

const DeliveryForm: React.FC<deliveryDetailsProps> = ({
  edit,
  onClose,
  handleDeliveryFormSubmit,
  handleAddressFieldOnChange,
  selectedAddress,
  editAddress,
  isDesktop,
  setShowForm
}) => {
  const DeliveryAddress = useSelector(
    (state: any) => state?.restaurant?.deliveryAddress?.addresses
  );

  const [tags, setTags] = useState<string[]>(() => {
    // Get all delivery address tags
    const deliveryAddressTags = DeliveryAddress?.map((address: any) => address?.tag) || [];      
    // Get selected address tag if exists
    const selectedAddressTag = editAddress?.tag;      
    // Combine all tags: default tags that are not previously selected + custom + selected address tag 
    const allTags = [
      ...defaultTags.filter((tag: string) => !deliveryAddressTags.includes(tag)),
      ...(selectedAddressTag? [selectedAddressTag] : []),
      "Custom"
    ];    
    // Remove duplicates and return
    return Array.from(new Set(allTags));
  });


  

  const editTag = tags?.find((tag: any) => editAddress?.tag === tag);

  const {
    register,
    handleSubmit,
    control,
    setValue,
    getValues,
    setError,
    clearErrors,
    watch,
    reset,
    formState: { errors, isSubmitted },
  } = useForm<FormData>({
    defaultValues: {
      addressLine1: "",
      apartment: "",
      state: "",
      city: "",
      zipcode: "",
      addressTag: edit ? editTag : tags[0],
      deliveryInstructions: "",
      location: ""
    },
    mode: "onSubmit",
    reValidateMode: "onChange",
  });

  const dispatch = useDispatch();
  const {
    ready,
    value: location,
    suggestions: { status, data },
    setValue: setLocation,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      /* Define search scope here */
    },
    debounce: 300,
  });

  const [customTag, setCustomTag] = useState("");
  const [showOtherTag, setShowOtherTag] = useState(false);
  const [flag, setFlag] = useState(false);
  const [selectedTag, setSelectedTag] = useState<any>();
  const [showDropdown, setShowDropdown] = useState(false);
  const [isSafari, setIsSafari] = useState(false);
  const [center, setCentre] = useState<ILatLong | null>(null);
  const [openEnableLocationPropmt, setOpenEnableLocationPropmt] = useState(false);

  const selectedDelivery = useSelector((state: any) => state.restaurant.selectedDeliveryAddress);
  const restaurantDetails = useSelector((state: any) => state.restaurant.currentRestaurantDetail);
  const locationDetails = useSelector((state: any) =>
    state.restaurant.currentRestaurantDetail.branch.filter((branch: any) => {
      return branch.id === restaurantDetails.id;
    })
  );


  useEffect(() => {
    if (editTag) {
      setValue("addressTag", editTag);
      setSelectedTag(editTag);
    }
  }, [editTag, setValue]);

  const handleTagClick = (tag: string) => {
    if (tag === "Custom") {
      setValue("addressTag", "");
      setCustomTag("");
      setShowOtherTag(true);
    } else {
      setValue("addressTag", tag);
      setShowOtherTag(false);
      setSelectedTag(tag);
      clearErrors("addressTag");
    }
  };

  // const generateUniqueId = () => {
  //   return (
  //     Date.now().toString() + "-" + Math.floor(Math.random() * 10000).toString()
  //   );
  // };

  const customerID = getCookie(USER_ID)
  const restaurantCountry = useSelector(
    (state: any) => state?.restaurant?.currentResCountry
  );
  const deliveryAddressLoading = useSelector(
    (state: any) => state.restaurant?.deliveryAddressLoading
  );
  const deliveryAddressFailure = useSelector((state: any) => state.restaurant?.deliveryAddressFailure)
  // const deliveryAddressFailureMessage = useSelector((state: any) => state.restaurant?.deliveryAddressFailureMessage?.message)

  // const addDeliveryAddressLoading = useSelector(
  //   (state: any) => state.restaurant?.addDeliveryAddressLoading
  // );
  // const editDeliveryAddressLoading = useSelector(
  //   (state: any) => state.restaurant?.editDeliveryAddressLoading
  // );
  const deliveryAddressSuccess = useSelector(
    (state: any) => state.restaurant?.deliveryAddressSuccess
  );
  const allDeliveryAddresses = useSelector(
    (state: any) => state.restaurant?.deliveryAddress?.addresses
  );
  const locationID = useSelector(
    (state: any) => state.restaurant.currentRestaurantDetail.id
  );

  useEffect(() => {
    let ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("safari") != -1) {
      if (ua.indexOf("chrome") > -1) {
        // Chrome
      } else {
        setIsSafari(true); // Safari
      }
    }
  }, []);


  useEffect(() => {
    if (deliveryAddressLoading === false && 
        flag && 
        deliveryAddressSuccess
      ) {
      reset()
      setShowForm(false)
      setFlag(false);
    }
  }, [deliveryAddressLoading, flag, deliveryAddressFailure, deliveryAddressSuccess]);


  useEffect(() => {
    if (isSubmitted) {
      if (location) {
        clearErrors("location");
      } else {
        const values=getValues()
        const isSameAsAddress = (
          values.city === editAddress?.city &&
          values.state === editAddress?.state &&
          values.zipcode === editAddress?.postalCd 
        );
        if(!edit || (edit && !isSameAsAddress)){
          setError("location", {
            type: "manual",
            message: "Location is required",
          });
        }else{
          clearErrors('location')
        }
      }
    }
  }, [isSubmitted, location]);

  const handleLocationChange = (val: string) => {
    setValue("location", val);
    setLocation(val)
    if (val) {
      setShowDropdown(true);

    } else {
      setShowDropdown(false);

    }
  }

  const onSubmit = (formData: FormData) => {
    // if (DeliveryAddress?.find((address: any) => address.tag === formData?.addressTag)) {
    //   showErrorToastDesktop("Address with this tag already exists");
    //   return;
    // }

    setFlag(true);

    if (edit) {
    
      
      let editAddressPayload = {
        id: editAddress?.id,
        customerId: customerID,
        tag: formData?.addressTag ? formData?.addressTag : editTag,
        addressLine1: formData?.addressLine1,
        addressLine2: formData?.apartment,
        city: formData?.city,
        state: formData?.state,
        latitude: editAddress?.latitude || center?.lat,
        longitude: editAddress?.longitude || center?.lng,
        postalCd: formData?.zipcode,
        countryCd: restaurantCountry,
      };

      // Validate all required fields
      const isValid = 
        !isEmptyOrWhitespace(editAddressPayload.customerId) &&
        !isEmptyOrWhitespace(editAddressPayload.tag) &&
        !isEmptyOrWhitespace(editAddressPayload.addressLine1) &&
        !isEmptyOrWhitespace(editAddressPayload.city) &&
        !isEmptyOrWhitespace(editAddressPayload.state) &&
        !isEmptyOrWhitespace(editAddressPayload.postalCd) &&
        !isEmptyOrWhitespace(editAddressPayload.countryCd) &&
        !isEmptyOrWhitespace(editAddressPayload.latitude) &&
        !isEmptyOrWhitespace(editAddressPayload.longitude);


      // Only dispatch if all fields are valid
      if (isValid) {
        dispatch(editDeliveryAddressRequest(editAddressPayload));
      }

    } else {
      let addAddressPayload = {
        customerId: customerID,
        tag: formData?.addressTag,
        addressLine1: formData?.addressLine1,
        addressLine2: formData?.apartment,
        city: formData?.city,
        state: formData?.state,
        latitude: center?.lat,
        longitude: center?.lng,
        postalCd: formData?.zipcode,
        countryCd: restaurantCountry,
        location:formData.location
        
      };
      dispatch(addDeliveryAddressRequest(addAddressPayload));
    }

    // if (center?.lat && center?.lng) {
    //   const payload: DeliveryChargeRequestBody = {
    //     locationId: locationID,
    //     pickupDetails: {
    //       Address: {
    //         streetAddress1: restaurantDetails.address,
    //         streetAddress2: "",
    //         city: restaurantDetails.city,
    //         state: "",
    //         pincode: "",
    //       },
    //       lat: restaurantLocationDetails?.latitude,
    //       lng: restaurantLocationDetails?.longitude,
    //     },
    //     receiverDetails: {
    //       name: "Brisque Customer",
    //       phoneNumber: "+16505555555",
    //     },
    //     senderDetails: {
    //       name: restaurantDetails.branchName,
    //       phoneNumber: restaurantDetails.phoneNumber,
    //     },
    //     dropDetails: {
    //       Address: {
    //         streetAddress1: formData.addressLine1,
    //         streetAddress2: formData?.apartment,
    //         city: formData?.city,
    //         state: formData?.state,
    //         pincode: formData?.zipcode,
    //       },
    //       lat: center?.lat,
    //       lng: center.lng,
    //     },
    //     locationProviderId: DeliveryProvider?.deliveryProviderId ?? "DOORDASH",
    //     tip: getDecimalPlacedPrice(Number(tipAmount)) * 100
    //   }
    //   dispatch(getDeliveryChargeInitiated(payload));
    // }
    if (handleDeliveryFormSubmit) {
      handleDeliveryFormSubmit(formData);
    }
  };



  const saveTag = (e: any) => {
    e.preventDefault();

    if (customTag.trim() === "") {
      setError("addressTag", { type: "manual", message: "Tag name cannot be empty" });
      return;
    }

    // Validate tag using the same rules as address validation
    const validationResult = validateTag(customTag);
    if (validationResult !== true) {
      setError("addressTag", { type: "manual", message: validationResult });
      return;
    }

    clearErrors("addressTag");


      // Get all delivery address tags
  const deliveryAddressTags = DeliveryAddress?.map((address: any) => address?.tag) || [];
  
  // Get selected address tag if exists
  const selectedAddressTag = editAddress?.tag;
  // if(deliveryAddressTags.includes(customTag)){
  //   setError("addressTag", { type: "manual", message: "Tag already exists" });
  //   return;
  // }
  // Combine all tags: default tags + custom + selected address tag + delivery address tags (excluding those already in default tags)
  const allTags = [
    ...defaultTags.filter((tag: string) => !deliveryAddressTags.includes(tag)),
    ...(selectedAddressTag ? [selectedAddressTag] : []),
    customTag,
    "Custom",
  ];
  
  // Remove duplicates and set
  const newTags = Array.from(new Set(allTags));


    setTags(newTags);
    setValue("addressTag", customTag);
    setShowOtherTag(false);
  };

  const handleTagKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === " " && customTag.length === 0) {
      e.preventDefault();
      return;
    }

    if (e.key === "Enter") {
      if (customTag.trim() !== "") {
        // Validate tag before saving
        const validationResult = validateTag(customTag);
        if (validationResult !== true) {
          setError("addressTag", {
            type: "manual",
            message: validationResult,
          });
          return;
        }
        saveTag(e);
      } else {
        setError("addressTag", {
          type: "manual",
          message: "Tag name cannot be empty",
        });
      }
    }
  };

  useEffect(() => {
    if (edit) {
      setValue("addressLine1", editAddress?.addressLine1);
      setValue("apartment", editAddress?.addressLine2);
      setValue("state", editAddress?.state);
      setValue("city", editAddress?.city);
      setValue("zipcode", editAddress?.postalCd);
      setValue("addressTag", editAddress?.addressTag);
      setValue("deliveryInstructions", editAddress?.deliveryInstructions);
    } else {
      setValue("addressLine1", editAddress?.addressLine1);
      setValue("apartment", editAddress?.apartment);
      setValue("state", editAddress?.state);
      setValue("city", editAddress?.city);
      setValue("zipcode", editAddress?.zipcode);
      setValue("addressTag", editAddress?.addressTag);
      setValue("deliveryInstructions", editAddress?.deliveryInstructions);
    }
  }, [edit, editAddress]);

  const clearInput = () => {
    setValue("location", "");
    setLocation('');
    setShowDropdown(false);
  };

  const selectSuggestion = async (suggestion: string,placeId:string) => {
    setLocation(suggestion);
    setShowDropdown(false);
    const results:any = await getGeocode({ address: suggestion });
    const { lat, lng } = await getLatLng(results[0]);
    setCentre({ lat, lng })
    const address: any = await parseAddressFromGoogle(suggestion,placeId);  
    setValue("addressLine1", address?.addressLine1);
    setValue("apartment", address?.apartment);
    setValue("state", address?.state);
    setValue("city", address?.city);
    setValue("zipcode", address?.zipcode);
    setValue("location", suggestion)
    setLocation(suggestion);


  };

  const loadCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        const results = await getGeocode({ location: { lat: center?.lat, lng: center?.lng } });
        const formattedAddress = results[0]?.formatted_address;
        const address: any = await parseAddressFromGoogle(formattedAddress,"")
        setCentre(center)
        setValue("addressLine1", address?.addressLine1);
        setValue("apartment", address?.apartment);
        setValue("state", address?.state);
        setValue("city", address?.city);
        setValue("zipcode", address?.zipcode);
        setValue("location", formattedAddress)
        setLocation(formattedAddress)

        setCentre(center)
      },
      (err: any) => {
        console.error(err);
        if (err.PERMISSION_DENIED) {
          setOpenEnableLocationPropmt(true);
        }
      }, { enableHighAccuracy: true }
    );
  };

  const requestLocationPermission = () => {
    if ("geolocation" in navigator) {
      navigator &&
        navigator.permissions &&
        navigator.permissions
          .query({ name: "geolocation" })
          .then(function (result) {
            if (result.state === "granted") {
              loadCurrentLocation();
            } else if (result.state === "prompt") {
              loadCurrentLocation();
            } else if (result.state === "denied") {
              setOpenEnableLocationPropmt(true);
            }
            result.onchange = function () {
              if (result.state === "denied") {
                setOpenEnableLocationPropmt(true);
              }
            };
          });
    } else {
      alert("Browser Does not Support Location Features");
    }
  };

  const locateUser = async () => {
    isSafari ?
      navigator.geolocation.getCurrentPosition(
        async function (position: any) {
          const center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          const results = await getGeocode({ location: { lat: center?.lat, lng: center?.lng } });
          const formattedAddress = results[0]?.formatted_address;
          const address: any = await parseAddressFromGoogle(formattedAddress,"")
          setCentre(center)
          setValue("addressLine1", address?.addressLine1);
          setValue("apartment", address?.apartment);
          setValue("state", address?.state);
          setValue("city", address?.city);
          setValue("zipcode", address?.zipcode);
          setValue("location", formattedAddress)
          setLocation(formattedAddress)

        },
        function (err: any) {
          if (err.code === err.PERMISSION_DENIED) {
            setOpenEnableLocationPropmt(true);
          }
          console.error("Error fetching current location! " + err.code, err.message);
        }
      ) : requestLocationPermission()
  };

  const proceed = (e: React.MouseEvent<HTMLButtonElement>) => {
    const values=getValues()
    const isSameAsAddress = (
        values.city === editAddress?.city &&
        values.state === editAddress?.state &&
        values.zipcode === editAddress?.postalCd 
      );
    if(edit && selectedDelivery?.id === editAddress?.id){
      setValue("location", "");
      dispatch(setSelectedDeliveryAddress({}))
    }
    if (!location) {
      setValue("location", "");
      const values=getValues()
      const isSameAsAddress = (
        values.city === editAddress?.city &&
        values.state === editAddress?.state &&
        values.zipcode === editAddress?.postalCd 
      );
      if(!edit || (edit && !isSameAsAddress)){
        setError("location", {
          type: "manual",
          message: "Location is required",
        });
      }else{
        clearErrors('location')
      }
    }

    if (tags.length <= 1 || 
      (!edit && watch("addressTag") === undefined) || 
      (!edit && watch("addressTag") === '') || 
      !selectedTag
      ) {
      setError("addressTag", {
        type: "manual",
        message: "Please select an address tag",
      });
      return;
    }
    // handleSubmit(onSubmit)();
  };

  const validTags = tags.filter((tag): tag is string => tag != null && tag !== '');
  
    return (
      <div className={isDesktop ? "delivery-form-overlay-desktop" : "delivery-form-overlay"}>
        <EnableLocationPrompt
          isOpen={openEnableLocationPropmt}
          closePrompt={() => setOpenEnableLocationPropmt(false)}
        />
        <div className={isDesktop ? "delivery-form-container-desktop" : "delivery-form-container"}>
          <img src={closeIcon} alt="" className="close-btn mobile-view" onClick={onClose} />
          <div className="form-header">
            <h2>{editAddress?.id?"Edit ":"Add "}Delivery Address</h2>
            <img src={closeIcon} alt="" className="close-btn mobile-view" onClick={onClose} />
          </div>
          <form className="delivery-form" onSubmit={handleSubmit(onSubmit)}>
            <div className="form-group ">
              <label>Enter your location <span className="input-asterisk">*</span></label>

              <div className="delivery-form-location-container">
                <span className="delivery-form-location-icon"><PositionIcon /></span>
                <input
                  placeholder="Enter your location"
                  className="delivery-form-location-input"
                  type="text"
                  value={location}
                  onChange={(e) => handleLocationChange(e.target.value)}
                  onKeyDown={(e) => {
                    if(location === '' && e.key === ' '){
                      e.preventDefault()
                    }
                  }}
                  autoComplete="new-password"
                />
                {location && (
                  <span className="delivery-form-location-clear" onClick={clearInput}>
                    <CloseIcon />
                  </span>
                )}
                <span className="delivery-form-location-locate" onClick={locateUser}>
                  <LocationIcon />
                </span>
              </div>
              {errors.location && (
                <p className="error">{errors.location.message}</p>
              )}
              {(showDropdown && data?.length) ? (
                <div className="location-dropdown">
                  {data.map((currentData, idx) => (
                    <div key={idx} className="location-suggestion" onClick={async () => await selectSuggestion(currentData?.description,currentData?.place_id)}>
                      {currentData?.description}
                    </div>
                  ))}
                  {/* TODO: we cannot use copyrighted name in app <div className="location-powered">powered by <span>Google</span></div> */}
                </div>
              ) : null}

            </div>
            <div className="form-group">
              <label>Address Line 1<span className="input-asterisk">*</span></label>
              <input
                type="text"
                autoComplete="new-password"
                maxLength={50}
                {...register('addressLine1', {
                  required: 'Address is required',
                  maxLength: {
                    value: 50,
                    message: 'Address must be under 50 characters',
                  },
                  validate: validateAddress,
                })}
                onChange={(e) => {
                  e.target.value = sanitizeAddress(e.target.value);
                }}
              />
              {errors.addressLine1 && (
                <p className="error">{errors.addressLine1.message}</p>
              )}
            </div>

            <div className="form-group">
              <label>Apartment / Suite </label>
              <input
                type="text"
                autoComplete="off"
                maxLength={30}
                {...register("apartment", {
                  maxLength: {
                    value: 30,
                    message: "Apartment must be under 30 characters",
                  },
                  validate: validateAddress,
                })}
                onChange={(e) => {
                  e.target.value = sanitizeAddress(e.target.value);
                }}
              />
              {errors.apartment && (
                <p className="error">{errors.apartment.message}</p>
              )}
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>State<span className="input-asterisk">*</span></label>
                <input
                  type="text"
                  maxLength={30}
                  {...register("state", {
                    required: "State is required",
                    validate: (value) => {
                      if (value && value.trim() === '') {
                        return 'Enter valid state';
                      }
                      return true;
                    },
                    maxLength: {
                      value: 30,
                      message: "State must be under 30 characters",
                    },
                    pattern: {
                      value: CITY_STATE_REGEX,
                      message:
                        "Only letters and spaces are allowed",
                    },
                  })}
                  onKeyDown={(e) => {
                    const allowedChars = /^[a-zA-Z\s]*$/;
                    const value = e.currentTarget.value;
                    if (
                      e.key === " " && value.length === 0
                    ) {
                      e.preventDefault();
                    }

                    if (
                      e.key.length === 1 &&
                      !allowedChars.test(e.key)
                    ) {
                      e.preventDefault();
                    }
                  }}
                autoComplete="new-password"
                />
                {/* <Controller
                  name="state"
                  control={control}
                  rules={{ required: "State is required" }}
                  render={({ field }) => (
                    <select {...field}>
                      <option value="">Select State</option>
                      {stateOptions.map((state) => (
                        <option key={state} value={state}>
                          {state}
                        </option>
                      ))}
                    </select>
                  )}
                /> */}
                {errors.state && <p className="error">{errors.state.message}</p>}
              </div>

              <div className="form-group city">
                <label>City <span className="input-asterisk">*</span></label>
                <input
                  type="text"

                  {...register("city", {
                    required: "City is required",
                    validate: (value) => {
                      if (value && value.trim() === '') {
                        return 'Enter valid city';
                      }
                      return true;
                    },
                    pattern: {
                      value: CITY_STATE_REGEX,
                      message:
                        "Only letters and spaces are allowed",
                    },
                  })}
                autoComplete="new-password"
                  maxLength={30}
                  onKeyDown={(e) => {
                    const allowedChars = CITY_STATE_REGEX;
                    const value = e.currentTarget.value;
                    if (e.key === " " && value.length === 0) {
                      e.preventDefault();
                    }
                    if (e.key.length === 1 && !allowedChars.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
                {errors.city && <p className="error">{errors.city.message}</p>}
              </div>

              <div className="form-group">
                <label>Zipcode <span className="input-asterisk">*</span></label>
                <input
                  type="text"
                  onKeyDown={(e) => {
                    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
                    if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  maxLength={restaurantDetails?.country === 'US' ? 5 : 6}
                  {...register("zipcode", {
                    required: "Zipcode is required",
                    pattern: {
                      value: /^\d{5,6}$/,
                      message: "Enter a valid zipcode",
                    },
                  })}
              autoComplete="new-password"
                />
                {errors.zipcode && (
                  <p className="error">{errors.zipcode.message}</p>
                )}
              </div>
            </div>

            <div className="address-tags">
              <label>Address Tag <span className="input-asterisk">*</span></label>
              <div className="tag-options">
                {validTags.map((tag: any) => (
                  <button
                    key={tag}
                    type="button"
                    className={`tag-btn ${selectedTag === tag ? "tag-active" : ""
                      }`}
                    onClick={() => handleTagClick(tag)}
                  >
                    {tag !== "Custom" ? (
                      tag
                    ) : (
                      <p onClick={() => setShowOtherTag(true)}>Custom</p>
                    )}
                    {tag === "Custom" && (
                      <img
                        src={editIcon}
                        alt="edit"
                        style={{ marginLeft: "15px" }}
                        onClick={() => setShowOtherTag(true)}
                      />
                    )}
                  </button>
                ))}
              </div>

              {showOtherTag && (
                <div className={isDesktop ? "form-group-tagName-desktop" : "form-group-tagName"}>
                  <input
                    type="text"
                    placeholder="Enter you address Tag"
                    value={customTag}
                    className="tag-input"
                    maxLength={15}
                    onChange={(e) => {
                      const sanitizedValue = sanitizeAddress(e.target.value);
                      setCustomTag(sanitizedValue);
                      // Clear errors when user starts typing
                      if (errors.addressTag) {
                        clearErrors("addressTag");
                      }
                    }}
                    onKeyDown={handleTagKeyDown}
                  />
                  <img src={tagicon} alt="Note" className="tag-icon" onClick={saveTag} />
                </div>
              )}
              {errors.addressTag && (
                <p className="error">{errors.addressTag.message}</p>
              )}
            </div>

            {/* <div className="form-group">
              <img src={noteIcon} alt="Note" className="note-icon" />
              <input
                type="text"
                maxLength={100}
                onKeyDown={(e) => {
                    const value = e.currentTarget.value;
                    if (
                      e.key === " " && value.length === 0
                    ) {
                      e.preventDefault();
                    }
                  }}

                placeholder="Type delivery instructions if any"
                {...register("deliveryInstructions", {
                  maxLength: {
                    value: 52,
                    message: "deliveryInstructions must be under 52 characters",
                  },
                })}
                className="note-input"
                autoComplete="new-password"
              />

            </div> */}

            <div className="form-actions">
              {allDeliveryAddresses?.length > 0  && 
                <button 
                  type="button" 
                  className="proceed-btn" 
                  onClick={onClose}
                >
                  Later
                </button>
              }

              <button
                type="submit"
                className="save-proceed-btn"
                onClick={(e) => proceed(e)}
              >
                Proceed
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  };

export default DeliveryForm;
